<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
                <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-4 col-4">
                    <h2>Manage Cusip</h2>
                    </div>
                    <div class="col-lg-8 col-8 text-right">
                        <form @submit.prevent="" class="d-inline-block justify-content-center headSearch mr-2">
                          <i @click="searchCusip()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                          <input v-on:keyup.enter="searchCusip" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm" type="text" placeholder="Search cusip" aria-label="Search">
                          <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                        </form>
                        <button  @click="openAddNewCusipModal()" type="button" class="btn btn-success rounded"><i class="fas fa-user-plus"></i> ADD NEW CUSIP</button>
                        <button v-if="isAdmin || isEditor"  @click="openUploadSMFileModal()" type="button" class="btn btn-success rounded"><i class="fas fa-user-plus"></i>UPLOAD SECURITY MASTER FILE</button>
                    </div>
                </div>
                <!-- Card stats -->
                </div>
            </div>
        </div>
        <div class="container-fluid mt--6">
            <div class="row xsOnly">
                <div class="col-xl-12">
                <div class="card scrollbar vh-75" id="scroll">
                    <div class="table-responsive">
                    <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                    <table class="table align-items-center table-flush table-hover bidtbl">
                        <thead class="thead-light psticky">
                        <tr >
                            <th 
                            scope="col" 
                            class="sort"
                            v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusip'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cusip'  ? 'sort-desc' : '']"  
                            @click="sort('cusip')">CUSIP/DESC</th>
                            <th 
                            scope="col" 
                            class="sort text-center"
                            v-bind:class="[sortOrder == 'ASC' && sortColumn == 'maturityDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'maturityDate'  ? 'sort-desc' : '']"  
                            @click="sort('maturityDate')">MATURITY DATE/<br>CALL DATE</th>
                            <th 
                            scope="col" 
                            class="sort"
                            >STATE/<br>INSURER</th>
                            <th 
                            scope="col" 
                            class="sort"
                            v-bind:class="[sortOrder == 'ASC' && sortColumn == 'coupon'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'coupon'  ? 'sort-desc' : '']"  
                            @click="sort('coupon')">COUPON</th>
                            <th 
                            scope="col" 
                            class="sort text-center"
                            v-bind:class="[sortOrder == 'ASC' && sortColumn == 'status'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'status'  ? 'sort-desc' : '']"  
                            @click="sort('status')"
                            >Status</th>
                            <th scope="col" class="text-center">Action</th>
                        </tr>
                        </thead>
                        <tbody class="list">
                        <tr v-if="totalRows == 0 && !loading">
                            <td><p class="nodata">No data available</p>
                            </td>
                        </tr>
                        <tr v-for="cusip in cusips" :key="cusip.id" @click="getCusipDetails(cusip)" v-bind:class="{'active-row': cusip.isActive}">
                            <td>
                            <span class="cusips">{{cusip.cusip}}</span>
                            <span class="desc">{{cusip.description}}</span>
                            </td>
                            <td class="text-center">
                            <span class="maturity">{{moment(cusip.maturityDate).format("MM/DD/YYYY")}}</span><br>
                            {{cusip.callDate ? moment(cusip.callDate).format("MM/DD/YYYY") : "N/A"}}
                            
                            </td>
                            <td>
                            <span class="state">{{getStateName(cusip.stateId)}}</span>
                            <span class="insurer">{{cusip.bondInsurer}}</span>
                            </td>
                            <td>
                            <span class="coupon">{{cusip.coupon | percent(3)}}</span>
                            </td>
                            <td class="text-center"><span class="badge" v-bind:class="cusip.status == 'ACTIVE' ? 'active' : 'deactive'">{{cusip.status}}</span></td>
                            <td class="text-center">
                            <div class="d-inline-flex">
                                <a  @click="openAddNewCusipModal(cusip)" class="editbtn"><i class="fas fa-pen-square green"></i></a>
                                <div class="dropdown">
                                    <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-ellipsis-v"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                        <button @click="openCusipOfferingModal(cusip)"   class="dropdown-item" type="button">Offerings</button>
                                        <button v-if="isAdmin || isEditor" @click="changeCusipStatus(cusip)" class="dropdown-item" type="button">{{cusip.status == 'BLOCKED' ? "UNBLOCK" : "BLOCK"}}</button>
                                    </div>
                                </div>
                            </div>
                            </td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- Pagination-->
                    <b-pagination
                        class="mt-4"
                        :total-rows="totalRows"
                        v-model="currentPage"
                        :per-page="perPage"
                        @input="getCusipList(currentPage)"
                    ></b-pagination>
                    <div class="total-records">
                        <span>Total Records : {{totalRows}}</span>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div>  
      <add-cusip 
        v-bind:addCusipObj="addCusipObj" 
        v-if="addCusipModalOpen" 
         @close="closeAddCusipModal()"
       ></add-cusip>
       <cusip-offering 
        v-bind:cusipData="cusipData" 
        v-if="cusipOfferingModalOpen" 
        @close="cusipOfferingModalOpen = false"
       ></cusip-offering >
       <smfileImport
        v-if="smFileModalOpen" 
        @close="smFileModalOpen = false"
       ></smfileImport>

    </div> 
      
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import stateConstants from "@/stateConstants";
import AddCusip from "@/components/bidside/trader/bid/AddCusip";
import CusipOffering from "./ImsCusipOfferingModal";
import smfileImport from "@/components/common/UploadSMFileModal.vue"
export default {
  name: "imsCusipComponent",
  components : {
      AddCusip,
      CusipOffering,
      smfileImport
  },
  data() {
    return {
        accessToken: null,
        cusips: [],
        config: config,
        loading : false,
        currentPage: 1,
        perPage: 10,
        searchValue : "",
        totalRows : 0,
        selectedCusip : "",
        sortColumn: "cusip",
        sortOrder: "ASC",
        addCusipModalOpen : false,
        cusipOfferingModalOpen : false,
        stateConstants: stateConstants,
        addCusipObj : null,
        cusipData : null,
        smFileModalOpen : false,
        isAdmin: false,
        isTrader : false,
        isEditor : false,
        isSuperAdmin : false,
    };
  },
  methods: {
    closeAddCusipModal(){
      this.addCusipModalOpen = false;
      this.getCusipList();
    },
    openCusipOfferingModal(cusip){
      this.cusipData = cusip
      this.cusipOfferingModalOpen = !this.cusipOfferingModalOpen
    },
    openUploadSMFileModal(){
      this.smFileModalOpen = true;
    },
    searchCusip(){
      this.getCusipList(); 
    },
    clearSearch(){
      this.searchValue = "";
      this.getCusipList(); 
    },
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.getCusipList();
    },
    getStateName(id){
      return id ? this.stateConstants.find(x => x.id === id).short : 'N/A';
    },
    getCusipDetails(cusipSelected){
      this.cusips.forEach(function(cusip) {
        cusip.isActive = false;
      });
      cusipSelected.isActive = true;
    },
    getCusipList(currentPage) {
      this.loading = true;
      if (!currentPage) {
        currentPage = 1;
      }
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlBidSide +
            "/cusip/list?page=" +
            currentPage +
            "&size=" +
            this.perPage +
            "&cusip=" +
            this.searchValue +
            "&status=ACTIVE,BLOCKED"+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&type=OFFER",
            auth

        )
        .then(result => {
          //console.log(result);
          this.totalRows = result.data.pageInfo.totalElements;
          result.data.content.forEach(function(cusip) {
           cusip.isActive = false;
          });
           this.cusips = result.data.content;
           this.loading = false;
        })
        .catch(e => {
          console.log("Error", e);
          //self.loading = false;
        });
    },
    openAddNewCusipModal(selectedCusip){
        if(selectedCusip){
            this.addCusipObj = selectedCusip;  
        }else{
            this.addCusipObj = {};
        }
        this.addCusipModalOpen = !this.addCusipModalOpen;
    },
    changeCusipStatus(selectedCusip){
      var message = "Are you sure you want to " + (selectedCusip.status == 'BLOCKED' ? "unblock" : "block") + " this CUSIP?";
      this.$confirm(message).then(() => {
        const auth = {
          headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
          .put(
            config.baseUrlBidSide + "/cusip/status",
            {
              cusipId : selectedCusip.id,
              cusipStatus : selectedCusip.status == 'BLOCKED' ? "ACTIVE" : "BLOCKED",
              type : "OFFER"
            },
            auth
          )
          .then(() => {
            this.getCusipList(this.currentPage);
          })
          .catch(e => {
            console.log(e);
          });
      })
    },
   
  },
  mounted() {
    this.getCusipList();
    this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          //console.log(role)
          this.tenantName = role[0].split("-")[0];
          var roleArray = role.map(item => {
            return  item.split("-")[1];
          })
          roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
          roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
          roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
          roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;
        }
      });

  }
};
</script>